import React from 'react'
import { Redirect } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel'
import { size as _size } from 'lodash'

import { HelmetComponent, Renew } from 'components'
import { OrderResult } from '../components'
import { PlanInput } from './components'

import { ProductHandler } from 'utils'
import 'assets/sass/ECommerce/product-detail.scss'


export class ProductDetail extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = { showToggler: false };
	}

	toPaymentHandler = (e) => {
		const {
			current_product,
			plan_id,
			onPayHandler,
			history,
			authenticated,

			onUserOrdersAddRequest,
			onRenewReset,
			onModalOpen,
		} = this.props;
		const plan = current_product.plans.find((productPlan) => (
			productPlan.id.toString() === plan_id.toString()
		));

		onRenewReset();

		/* do something that show message */
		if (!plan) { return false; }

		if (plan.price === 0) {
			let list = [{ id: current_product.id, plan: plan_id }];

			if (authenticated) {
				ReactPixel.track(
					'StartTrial',
					{ value: '0.00', currency: 'TWD', predicted_ltv: '0.00' }
				);

				onUserOrdersAddRequest({ products: list, paymentType: 'free' });

				onModalOpen('add-single');
			} else {
				history.push('/login-page');
			}
		} else {
			if (authenticated) {
				ReactPixel.track('InitiateCheckout');

				let orderProducts = [];

				orderProducts.push({
					name: current_product.name,
					id: current_product.id,
					price: plan.price,
					brand: 'UAnalyze',
					category: current_product.type,
					variant: '',
					expiration: plan.expiration,
				});

				window.dataLayer.push({
					event: 'checkout',
					ecommerce: {
						checkout: {
							actionField: { step: 1, option: '' },
							products: orderProducts,
						},
					},
				});
			}

			onPayHandler(current_product, plan_id);

			history.push('/payment');
		}
	}

	planChangeHandler = (e) => {
		const planID = e.target.dataset.plan;

		this.props.onPlanSet(planID);
	}

	togglerHandler = (e) => {
		this.setState({ showToggler: !this.state.showToggler });
	}

	componentWillUnmount() {
		const { current_product, onCurrentProductClear } = this.props;

		if (current_product) { onCurrentProductClear(); }
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			current_product,
			onPlanSet,
			onProductDetailLoad,
			result,
			onLabListLoadRequest,
			onCurrentProductSet,
		} = this.props;

		if (prevProps.current_product !== current_product && current_product) {
			const { name, plans } = current_product;

			if (plans.length > 0) { onPlanSet(plans[0].id); }

			ReactPixel.track('ViewContent', { content_name: name });
		}

		if (prevProps.current_product && !current_product) { onProductDetailLoad(); }

		if (prevProps.result !== result && result === 1) {
			onLabListLoadRequest();
			onCurrentProductSet({ ...current_product, owned: 1 });
		}
	}

	componentDidMount() {
		const { current_product, onProductDetailLoad } = this.props;

		if (!current_product) { onProductDetailLoad(); }
	}

	render() {
		const showToggler = this.state.showToggler;
		const {
			productID,
			current_product,
			load_error,
			result,
			plan_id,
			is_mobile,
			// history,
		} = this.props;

		let component = null;

		if (load_error) {
			component = <Redirect to='/e-com/product-view/collection' />;
		} else if (current_product) {
			const {
				name,
				category,
				avatar_small,
				info_short,
				info_more,
				plans,
				tags,
				owned,
				status,
			} = current_product;
			const plan = plans.find((plan) => (plan.id === plan_id));
			const categoryComponent = tags.map((item, idx) => (
				<small className='txt-grey' key={idx}>{item.name}</small>
			));
			const planComponent = plans.map((item, idx) => (
				<PlanInput
					item={item}
					idx={idx}
					planChangeHandler={this.planChangeHandler}
					key={idx}
				/>
			));

			component = (
				<div className='product-detail-view col-12'>
					<HelmetComponent
						title={`優分析 UAnalyze 商城－${name}`}
						description={info_short}
						img={(avatar_small && _size(avatar_small) > 0)
							? avatar_small.url : null}
						href={`/e-com/product-detail/${productID}/`}
					/>

					<div className='product-detail ua-box default padding-15 row'>
						<div className='product-detail-header col-12'>
							<h1>{name}</h1>

							{categoryComponent}
						</div>

						<div className='product-detail-body col-sm-12 col-md-12 col-lg-8'>
							<ProductHandler.HTMLRenderer
								className='text-justify'
								htmlType='p'
								html={info_more}
							/>
						</div>

						<form
							className='price-container ua-form ua-box white margin-0
									padding-10 padding-horizontal-20 text-center col-sm-12
									col-md-12 col-lg-3'
							name='price-container-form'
						>
							<h3 className='txt-black d-inline-block txt-normal'>
								{name}
							</h3>

							<div className={`${is_mobile ? `d-${showToggler
								? 'block' : 'none'}` : ''}`}>
								{planComponent}
							</div>

							{(status !== 1)
								?
								<div className='book-submit submit ua-btn default disabled'>
									訂閱方案暫時關閉
								</div>
								:
								is_mobile
									?
									showToggler
										?
										(plan && plan.price === 0 && owned === 1)
											?
											<div className='ua-btn default disabled'>已新增</div>
											:
											<div
												className='book-submit submit ua-btn default'
												onClick={this.toPaymentHandler}
											>
												新增策略包
											</div>
										:
										<div
											className='book-submit submit ua-btn default'
											onClick={this.togglerHandler}
										>
											選擇方案
										</div>
									:
									(plan && plan.price === 0 && owned === 1)
										?
										<div className='ua-btn default disabled'>已新增</div>
										:
										<div
											className='book-submit submit ua-btn default'
											onClick={this.toPaymentHandler}
										>
											新增策略包
										</div>}

							<Renew
								className='margin-bottom-10'
								btnName='領取續約優惠 (限時)'
								product={current_product}
							// history={history}
							/>
						</form>
					</div>

					<OrderResult result={((category === '3' || category === '4')
						&& result === 1) ? 3 : result} />
				</div>
			);
		}

		return component;
	}
}
